import styled, {keyframes} from "styled-components"

export const ToolTipContainer = styled.div`
  border-radius: 5px;
  padding: 20px;
  background-color: ${({theme}) => theme.colors.greys.white};
  max-width: 350px;
`

export const RelaDiv = styled.div`
  position: relative;
`

export interface ProgressCircleProps {
  active?: boolean
}
export const ProgressCircle = styled.div<ProgressCircleProps>`
  margin: 0 3px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 1px solid ${({theme}) => theme.colors.greys.medium};
  background-color: ${({active, theme}) => (active ? theme.colors.greys.mediumLight : theme.colors.greys.white)};
`

export const innerBeaconAnimation = keyframes`
  20% {
    opacity: 0.9;
  }

  90% {
    opacity: 0.7;
  }
`

export const outerBeaconAnimation = keyframes`
  0% {
    transform: scale(1);
  }
  45% {
    opacity: 0.7;
    transform: scale(0.75);
  }

  100% {
    opacity: 0.9;
    transform: scale(1);
  }
`

export const BeaconOuter = styled.span`
  cursor: pointer;
  animation: ${outerBeaconAnimation} 1.2s ease-in-out infinite;
  background-color: ${({
    theme: {
      colors,
      colorFunctions: {rgba}
    }
  }) => rgba(colors.perkbox.blue, 0.2)};
  border: 2px solid ${({theme}) => theme.colors.perkbox.blue};
  border-radius: 50%;
  display: inline-block;
  height: 45px;
  width: 45px;
  opacity: 0.9;
  transform-origin: center;
`

export const BeaconInner = styled.span`
  cursor: pointer;
  animation: ${innerBeaconAnimation} 1.2s infinite ease-in-out;
  background-color: ${({theme}) => theme.colors.perkbox.blue};
  border-radius: 50%;
  display: inline-block;
  height: 50%;
  left: 50%;
  opacity: 0.7;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 50%;
`
